<div class="wrap">
  <h1>Camera information</h1>

  <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker-cluster
      imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m"
    >
      <ng-container *ngFor="let d of dataSource?.filteredData">
        <agm-marker
          [agmFitBounds]="true"
          [latitude]="d.location.lat"
          [longitude]="d.location.lng"
        >
        </agm-marker>
      </ng-container>
    </agm-marker-cluster> </agm-map
  ><br />

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="camera">
      <th mat-header-cell *matHeaderCellDef>Camera</th>
      <td mat-cell *matCellDef="let element">{{ element.camera }}</td>
    </ng-container>

    <ng-container matColumnDef="batterie">
      <th mat-header-cell *matHeaderCellDef>Battery</th>
      <td mat-cell *matCellDef="let element">{{ element.batterie }}</td>
    </ng-container>

    <ng-container matColumnDef="infraction">
      <th mat-header-cell *matHeaderCellDef>nombre d'infractions</th>
      <td mat-cell *matCellDef="let element">{{ element.infraction }}</td>
    </ng-container>

    <p>test</p>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    >
  </table>
</div>
